import { usePutHttp } from "../../../../hooks/http/http.hook";
import type { IPost } from "../../../../types/models/post.models.types";

export interface IPostResponse {
  post: IPost;
}

interface IBody {
  message: string;
}

export function useRejectPostHttp() {
  return usePutHttp<IBody, IPostResponse>({
    path: "/brand/posts/:id/reject-post",
  });
}
